/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  const filter_triggers = document.querySelectorAll('[trigger-drawer]');
  /* simple filter drawer logic */
  filter_triggers.forEach(filter_trigger => {
    const trigger = filter_trigger.getAttribute('trigger-drawer');
    const nodeToTrigger = !!trigger ? document.querySelector('#'+trigger) : null;
    const sameTriggers = Array.from(filter_triggers).filter(sameTrigger => sameTrigger.getAttribute('trigger-drawer') === trigger);
    document.body.addEventListener('click', event => {
      if(!nodeToTrigger.contains(event.target) && !sameTriggers.some(filter_trigger => filter_trigger.contains(event.target))){
        filter_trigger.classList.remove('open');
        if(!!nodeToTrigger)
          nodeToTrigger.classList.remove('open');
      }
    });
    filter_trigger.addEventListener('click', event => {
      if(nodeToTrigger.classList.contains('open')){
        sameTriggers.forEach(sameTrigger => sameTrigger.classList.remove('open'))
        if(!!nodeToTrigger)
          nodeToTrigger.classList.remove('open');
      }else{
        sameTriggers.forEach(sameTrigger => sameTrigger.classList.add('open'))
        if(!!nodeToTrigger)
          nodeToTrigger.classList.add('open');
      }
    });
  });
})();

function controllFreeCompatibiltyProducts(){
  const rearWheelsInCart = document.querySelectorAll('.cart__item[is_rear_wheel]');
  const freeCompProducts = document.querySelectorAll('.cart__item[free-compatibility-product]');
  if(freeCompProducts){
    //get amounts of each produkt type
    var freeCompProductsAmount = 0;
    var rearWheelsInCartAmount = 0;
    freeCompProducts.forEach((freeCompInCart)=>{
      var qty = freeCompInCart.querySelector('input.cart__quantity-field')?.value;
      if(qty){
        freeCompProductsAmount = freeCompProductsAmount + parseInt(qty);
      }
    })
    if(rearWheelsInCart){
      rearWheelsInCart.forEach((wheelInCart)=>{
        var qty = wheelInCart.querySelector('input.cart__quantity-field')?.value;
        if(qty){
          rearWheelsInCartAmount = rearWheelsInCartAmount + parseInt(qty);
        }
      })
    }
    if(rearWheelsInCartAmount < freeCompProductsAmount){
      var amountToRemove = freeCompProductsAmount - rearWheelsInCartAmount;
      const updates = {}
      freeCompProducts.forEach((compProduct)=>{
        if(amountToRemove != 0){
          const compProductQty = compProduct.querySelector('input.cart__quantity-field')?.value;
          const compLineKey = compProduct.querySelector('input.cart__quantity-field')?.getAttribute('data-id');
          if(compProductQty && compLineKey){
            var productQty = parseInt(compProductQty);
            if(productQty >= amountToRemove){
              updates[compLineKey] = productQty - amountToRemove;
              amountToRemove = 0;
            } else {
              updates[compLineKey] = 0;
              amountToRemove = amountToRemove - productQty;
            }
          }
        }
      })
      // remove via cart api
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      })
      .then(response => {
        document.dispatchEvent(new Event('cart:items:changed'))
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
  }
}
window.addEventListener('load', (e)=>{
  controllFreeCompatibiltyProducts()
})
window.addEventListener('theme:cart:change', (e)=>{
  controllFreeCompatibiltyProducts()
})
